<template>
	<router-view class="build_matrix_box"></router-view>
</template>


<script>
	import Vue from 'vue'
	export default {
		data() {
		   return {
		      displacement: {
		        scale: 1
		      }
		    }
		},
		mounted() {
			let that = this;
			
			setTimeout(function(){
				//水印
        let name = Vue.cookie.get('name') || ''
        let now = new Date()
        let date = `${now.getFullYear()}-${now.getMonth()+1}-${now.getDate()} ${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`
				that.$watermark.set(name+" "+date)
				
				//缩放
				// that.$nextTick(() => {
				//   // 获取放大或缩小的区域DOM
				//   let matrix_box = document.querySelector(".build_matrix_box");
				//   matrix_box.addEventListener("touchstart", function(event) {
				// 	var touches = event.touches;
				// 	var events = touches[0];
				// 	var events2 = touches[1];
						 
				// 	// event.preventDefault();
						 
				// 	// 第一个触摸点的坐标
				// 	that.displacement.pageX = events.pageX;
				// 	that.displacement.pageY = events.pageY;
						 
				// 	that.displacement.moveable = true;
						 
				// 	if (events2) {
				// 	  that.displacement.pageX2 = events2.pageX;
				// 	  that.displacement.pageY2 = events2.pageY;
				// 	}
						 
				// 	that.displacement.originScale = that.displacement.scale || 1;
				// 	// console.log(that.displacement);
				//   });
				//   document.addEventListener("touchmove", function(event) {
				// 	if (!that.displacement.moveable) {
				// 	  return;
				// 	}
						 
				// 	event.preventDefault();
						 
				// 	var touches = event.touches;
				// 	var events = touches[0];
				// 	var events2 = touches[1];
				// 	// 双指移动
				// 	if (events2) {
				// 	  // 第2个指头坐标在touchmove时候获取
				// 	  if (!that.displacement.pageX2) {
				// 		that.displacement.pageX2 = events2.pageX;
				// 	  }
				// 	  if (!that.displacement.pageY2) {
				// 		that.displacement.pageY2 = events2.pageY;
				// 	  }
						 
				// 	  // 双指缩放比例计算
				// 	  var zoom =
				// 		that.getDistance(
				// 		  {
				// 			x: events.pageX,
				// 			y: events.pageY
				// 		  },
				// 		  {
				// 			x: events2.pageX,
				// 			y: events2.pageY
				// 		  }
				// 		) /
				// 		that.getDistance(
				// 		  {
				// 			x: that.displacement.pageX,
				// 			y: that.displacement.pageY
				// 		  },
				// 		  {
				// 			x: that.displacement.pageX2,
				// 			y: that.displacement.pageY2
				// 		  }
				// 		);
				// 	  // 应用在元素上的缩放比例
				// 	  var newScale = that.displacement.originScale * zoom;
				// 	  // 最大缩放比例限制
				// 	  if (newScale > 3) {
				// 		newScale = 3;
				// 	  }else if(newScale < 1){
				// 		 newScale = 1 
				// 	  }
				// 	  // 记住使用的缩放值
				// 	  that.displacement.scale = newScale;
				// 	  // 图像应用缩放效果
				// 	  // console.log(newScale);
				// 	  matrix_box.style.transform = "scale(" + newScale + ")";
				// 	  // 设置旋转元素的基点位置
				// 	  matrix_box.style.transformOrigin = "0px 50% 0px";
				// 	}
				//   });
				// });
			},1200)
			
			
		},
		methods: {
		    getDistance(start, stop) {
		      // Math.hypot()计算参数的平方根
		      return Math.hypot(stop.x - start.x, stop.y - start.y);
		    },
		}
	}
</script>

<style>
	body{
	  font-family: 'Avenir', Helvetica, Arial, sans-serif;
	  -webkit-font-smoothing: antialiased;
	  -moz-osx-font-smoothing: grayscale;
    background-color: #fff!important;
	}
	table {
	  width: 100%;
	  margin: auto;
	  /*border: 1px solid gainsboro;*/
	  border-collapse: collapse;
	  table-layout: fixed;
	}
	table td {
	  /*border: 1px solid gainsboro;*/
    border-bottom: 1px solid gainsboro;
    border-right: 1px solid gainsboro;
	  font: 1.1em/1.5 arial, microsoft yahei, snans-serif;
	  padding: 6px;
	  text-align: center;
	  white-space: nowrap; /*控制单行显示*/
	  overflow: hidden; /*超出隐藏*/
	  text-overflow: ellipsis; /*隐藏的字符用省略号表示*/
	  font-size: 12px;
	}

	table thead {
	  background-color: gainsboro;
	  font-size: 12px;
	}
	.doTask{
		background-color: ghostwhite;padding: 8%;margin-top: 10px;
	}
	
	
	.m-row {
		width: 100%;border: 1px solid #eeeeee;margin: 5px auto;font-size: 12px;padding: 5px;
	}
	.m-row-row {
		display: flex;flex-direction: row;align-items: center;
	}
	.m-row-row-padding {
		margin-left: 20px;
	}

  .van-field__label {
    color: #aaaaaa !important;
  }
</style>
